export {
  useAdminRole,
  useAdminFeedback,
  useAdminUsers,
  useAdminMetrics,
  useAdminMetricsV2,
  useAdminActivityLog,
  useAdminFeedbackDetail,
  useUpdateFeedbackStatus,
  useUpdateFeedbackPriority,
  useAddFeedbackNote,
  useAdminUserDetail,
  useAdminUserActivity,
} from './use-admin';

export { hasPermission, ADMIN_PERMISSIONS, ADMIN_ROLE_LABELS } from './types';

export type {
  AdminSubRole,
  AdminRole,
  AdminFeedbackItem,
  AdminDashboardMetrics,
  AdminDashboardMetricsV2,
  AdminUserItem,
  AdminPermission,
  FeedbackStatus,
  FeedbackPriority,
  AdminFeedbackNote,
  FeedbackDetailData,
  AdminActivityLogEntry,
  AdminUserDetail,
  UserActivityEvent,
  UserActivitySummary,
} from './types';

export { useExecutiveDashboard } from './use-executive-dashboard';

export type {
  UserGrowthRow,
  FunnelStage,
  RetentionCohort,
  MatchingFunnelRow,
  SideBalance,
  EngagementFeature,
  SessionAnalytics,
  ExecutiveKPIs,
  ExecutiveDashboardData,
} from './use-executive-dashboard';

export { useProductDashboard } from './use-product-dashboard';

export {
  summarizeHealthToday,
  recomputeAlerts,
  summarizeLatestRun,
  labelRetrieval,
  mapRetrievalEvents,
  utcDay,
  sampleLlmUsageRows,
  sampleScoringRun,
  sampleRetrievalEvents,
  useHealthUsageRows,
  useLatestScoringEvals,
  useRecentRagRetrieval,
  ALERT_THRESHOLDS,
  RETRIEVAL_LOW_SIMILARITY,
} from './use-ai-quality';

export type {
  HealthDay,
  HealthModelRow,
  HealthToday,
  HealthTrendPoint,
  UsageAlert,
  AlertKind,
  RecomputedAlerts,
  ScoringEvalCase,
  LatestScoringRun,
  RetrievalStatus,
  RetrievalEvent,
  RagRetrievalResult,
} from './use-ai-quality';

export type {
  TimeRange,
  EngagementOverview,
  FeatureAdoptionRow,
  JourneyStep,
  JourneyData,
  SessionBucket,
  SessionDepthData,
  SearchAnalytics,
  ContentEngagement,
  MatchingQuality,
  ChurnDataPoint,
  ChurnAnalysis,
  ProductDashboardData,
} from './use-product-dashboard';
